import angular from 'angular';
import template from './template.html';

export class CopyToClipboard {
    textToCopy = '';

    /* @ngInject */
    constructor(NotificationService, clipboard) {
        this.clipboard = clipboard;
        this.NotificationService = NotificationService;
    }

    $onChanges() {
        this.textToCopy = this.text;
    }

    copyToClipboard = () => {
        const getEscapedTextFromHTML = CopyToClipboard.getEscapedTextFromHTML(this.textToCopy);
        if (!getEscapedTextFromHTML) {
            return;
        }
        this.clipboard.copyText(getEscapedTextFromHTML);
        this.NotificationService.success('Copied');
    };

    static getEscapedTextFromHTML(text) {
        const block = document.createElement('div');
        block.innerHTML = text;
        return block.textContent || block.innerText || '';
    }
}

export const CopyToClipboardConfiguration = {
    template,
    controller: CopyToClipboard,
    controllerAs: 'ctrl',
    bindings: {
        text: '<',
        className: '@',
    },
};

angular.module('TALENYA-FE').component('copyToClipboard', CopyToClipboardConfiguration);
